import { ProvenanceBlock } from "../ProvenanceBlock";

const DETAIL_PL = {
  elevation_m: "Wysokość terenu", vertical_datum: "Układ wysokości", unit: "Jednostka",
  hazard_area_hits: "Trafienia w obszary zagrożenia", risk_zone_hits: "Trafienia w strefy ryzyka",
  acts_total: "Liczba aktów w rejestrze", coverage: "Zasięg danych",
  min_elevation_m: "Wysokość min. (m n.p.m.)", max_elevation_m: "Wysokość maks. (m n.p.m.)",
  mean_elevation_m: "Wysokość średnia (m n.p.m.)", median_elevation_m: "Wysokość medianowa (m n.p.m.)",
  elevation_range_m: "Rozpiętość wysokości (m)", centroid_elevation_m: "Wysokość w środku działki (m n.p.m.)",
  parcel_cells: "Komórki rastra 1 m w działce", slope_pct: "Spadek reprezentatywny (%)",
  dominant_aspect_pl: "Dominująca ekspozycja", dominant_aspect_deg: "Ekspozycja (° od N)",
  rel_elevation_50m_m: "Względem otoczenia 50 m (m)", rel_elevation_100m_m: "Względem otoczenia 100 m (m)",
  rel_elevation_250m_m: "Względem otoczenia 250 m (m)",
  lowest_zone_pl: "Strefa najniższa", highest_zone_pl: "Strefa najwyższa",
  ponding_status: "Obniżenia terenowe (status)", ponding_zones: "Liczba obniżeń w działce",
  ponding_max_depth_m: "Maks. głębokość modelowa obniżenia (m)",
  entry_edges: "Modelowe punkty dopływu", exit_edges: "Modelowe punkty odpływu",
  catchment_m2: "Lokalny zlew modelowy (m²)",
  runoff_concentration_cells: "Komórki koncentracji spływu",
  runoff_concentration_pct: "Udział koncentracji spływu (%)",
  max_flow_accumulation_cells: "Maks. akumulacja spływu (komórki)",
};
const LABEL_KEYS = ["label_pl", "kompleks_label_pl", "name", "title_pl", "numer", "number", "id"];

const itemLabel = (it) => {
  if (typeof it !== "object" || it === null) return String(it);
  for (const k of LABEL_KEYS) if (it[k]) return String(it[k]);
  return Object.values(it).filter((v) => typeof v === "string").join(" · ").slice(0, 140);
};

export const FindingSection = ({ f, t, testId }) => {
  if (!f || !f.status) {
    return (
      <div className="rounded-lg border border-dashed border-slate-300 p-4 text-sm text-slate-500" data-testid={testId}>
        {t("dd.finding.empty")}
      </div>
    );
  }
  const status = f.unavailable ? t("dd.finding.unavailable") : (f.badge_pl || f.status);
  const scalars = Object.entries(f.details || {})
    .filter(([, v]) => v === null || ["string", "number", "boolean"].includes(typeof v))
    .sort(([a], [b]) => a.localeCompare(b));
  const lists = Object.entries(f.details || {})
    .filter(([, v]) => Array.isArray(v))
    .sort(([a], [b]) => a.localeCompare(b));
  return (
    <div className="rounded-lg border border-slate-300 p-4" data-testid={testId}>
      <span className={`inline-block rounded border-2 px-2.5 py-1 text-xs font-bold uppercase tracking-wider ${
        f.unavailable || f.uncertain ? "border-dashed border-slate-400 text-slate-600" : "border-slate-900 text-slate-900"
      }`} data-testid={`${testId}-status`}>{status}</span>
      {f.unavailable && <p className="mt-2 text-xs font-semibold text-slate-600">{t("dd.unavailableNote")}</p>}
      {f.relationship && (
        <p className="mt-2 text-sm text-slate-700" data-testid={`${testId}-relationship`}>
          <b>{t("dd.relationship")}:</b> {f.relationship}
        </p>
      )}
      {f.note_pl && <p className="mt-2 text-sm leading-relaxed text-slate-700">{f.note_pl}</p>}
      {scalars.length > 0 && (
        <table className="mt-3 w-full border-collapse text-xs">
          <tbody>
            {scalars.map(([k, v]) => (
              <tr key={k} className="border-b border-slate-100">
                <td className="w-40 py-1 pr-3 align-top text-[10px] uppercase tracking-wider text-slate-500">{DETAIL_PL[k] || k}</td>
                <td className="py-1">{v === null ? "—" : (v === true ? "tak" : (v === false ? "nie" : String(v)))}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {lists.map(([k, items]) => (
        <div key={k} className="mt-3">
          <div className="text-[10px] font-bold uppercase tracking-wider text-slate-500">
            {DETAIL_PL[k] || k} ({items.length})
          </div>
          <ul className="mt-1 list-disc space-y-0.5 pl-5 text-xs text-slate-700">
            {items.slice(0, 8).map((it, i) => <li key={i}>{itemLabel(it).slice(0, 160)}</li>)}
            {items.length > 8 && <li>… +{items.length - 8}</li>}
          </ul>
        </div>
      ))}
      <ProvenanceBlock p={f.provenance || {}} t={t} testId={`${testId}-prov`} />
    </div>
  );
};
